import { createReducer } from '@reduxjs/toolkit';
import UserStoreActions from './UserStoreActions';
import { UserStoreState } from './UserStoreState';

const initialState: UserStoreState = {
  moonLists: []
};
export const userStoreReducer = createReducer<UserStoreState>(initialState, (builder) => {
  builder.addCase(UserStoreActions.setCurrentUser, (state, action) => ({ ...state, currentUser: action.payload }));
  builder.addCase(UserStoreActions.setCurrentUserSettings, (state, action) => ({
    ...state,
    currentUser: state.currentUser
      ? {
          ...state.currentUser,
          settings: action.payload
        }
      : undefined
  }));
  builder.addCase(UserStoreActions.setCurrentUserRun, (state, action) => ({
    ...state,
    currentUser: state.currentUser ? { ...state.currentUser, run: action.payload } : undefined
  }));
  builder.addCase(UserStoreActions.setCurrentUserMoonLists, (state, action) => ({
    ...state,
    moonLists: action.payload
  }));
  builder.addCase(UserStoreActions.addFavoriteMoonList, (state, action) => ({
    ...state,
    currentUser: state.currentUser
      ? { ...state.currentUser, favoriteMoonLists: [...state.currentUser.favoriteMoonLists, action.payload] }
      : undefined
  }));
  builder.addCase(UserStoreActions.removeFavoriteMoonListWithId, (state, action) => ({
    ...state,
    currentUser: state.currentUser
      ? {
          ...state.currentUser,
          favoriteMoonLists: state.currentUser.favoriteMoonLists.filter((moonList) => moonList.id !== action.payload)
        }
      : undefined
  }));
});
